<template>
  <el-row v-loading="mainLoading">
    <el-col>
      <span
        v-if="dot"
        style="position: fixed; top: 10px; right: 10px; border-radius: 5px; width: 10px; height: 10px; display: block; background: red;"
      ></span>
      <el-tabs v-model="check">
        <el-tab-pane label="Check In" name="check_in">
          <el-form ref="form" :model="form" label-width="200px" label-position="top">
            <el-row :gutter="20" class="hide">
              <el-col>
                <el-form-item label="Show current called student Name">
                  <el-button type="primary" @click="check_in" :loading="checkLoading.in">Send</el-button>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item label="Student Name">
                  <el-select
                    v-model="form.name"
                    filterable
                    remote
                    reserve-keyword
                    placeholder="Student Name"
                    :remote-method="remoteMethod"
                    :loading="loading"
                  >
                    <el-option
                      v-for="item in student"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>

                <el-tag v-if="extend.lunch" type="success">LUNCH</el-tag>

                <el-tag v-if="extend.extend" type="warning">EXTEND</el-tag>

                <el-tag v-if="extend.pc" type="danger">PC</el-tag>
              </el-col>

              <el-col :span="8">
                <el-form-item label="Temperature">
                  <!--                  <el-button type="primary" @click="check_in" v-if="extend.medical !== 'yes'">Check</el-button>-->
                  <el-popover class="keyboard" placement="bottom" width="280">
                    <vue-akeyboard
                      ref="kb"
                      :ele="`temperature`"
                      :keys="keys"
                      @click="handleKeyboardClick"
                      style="width: 280px; height: 200px"
                    ></vue-akeyboard>
                    <el-input id="temperature" slot="reference" placeholder="37.5" readonly v-model="form.temperature">
                    </el-input>
                  </el-popover>
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item label="Course">
                  <el-input type="text" readonly v-model="form.course"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="Parent Name">
                  <el-select
                    v-model="form.parent"
                    multiple
                    filterable
                    allow-create
                    default-first-option
                    placeholder="Parent Name"
                  >
                    <el-option
                      v-for="item in parents"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <!--              <el-col :span="6">-->
              <!--                <el-form-item label="Secret code (first time sign in)">-->
              <!--                  <el-input type="text" v-model="form.code"></el-input>-->
              <!--                </el-form-item>-->
              <!--              </el-col>-->
              <!--            </el-row>-->

              <!--            <el-row :gutter="20">-->
              <el-col :span="8">
                <el-form-item label="Medical">
                  <!--                  <el-button type="primary" @click="check_in" v-if="extend.medical !== 'yes'">Check</el-button>-->
                  <el-input placeholder="no" v-model="extend.medical" readonly>
                    <el-button
                      slot="append"
                      v-if="extend.medical !== 'yes' && form.name !== ''"
                      @click="medical"
                      v-loading="medicalLoading"
                      >Submit
                    </el-button>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20" class="show">
              <el-col>
                <el-form-item label="Show current called student Name">
                  <el-button type="primary" @click="check_in" :loading="checkLoading.in">Send</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="Check Out" name="check_out">
          <el-form ref="form" :model="form" label-width="200px" label-position="top">
            <el-row :gutter="20" class="hide">
              <el-col>
                <el-form-item label="Show current called student Name">
                  <el-button type="primary" @click="check_out" :loading="checkLoading.out">Send</el-button>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item label="Student Name">
                  <el-select
                    v-model="form.name"
                    filterable
                    remote
                    reserve-keyword
                    placeholder="Student Name"
                    :remote-method="remoteMethodOut"
                    :loading="loading"
                  >
                    <el-option
                      v-for="item in studentOut"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>

                <el-tag v-if="extend.lunch" type="success">LUNCH</el-tag>

                <el-tag v-if="extend.extend" type="warning">EXTEND</el-tag>

                <el-tag v-if="extend.pc" type="danger">PC</el-tag>
              </el-col>
              <el-col :span="8">
                <el-form-item label="Course">
                  <el-input type="text" readonly v-model="form.course"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="Parent Name">
                  <el-select
                    v-model="form.parent"
                    multiple
                    filterable
                    allow-create
                    default-first-option
                    placeholder="Parent Name"
                  >
                    <el-option
                      v-for="item in parents"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <!--              <el-col :span="6">-->
              <!--                <el-form-item label="Secret code (first time sign in)">-->
              <!--                  <el-input type="text" v-model="form.code"></el-input>-->
              <!--                </el-form-item>-->
              <!--              </el-col>-->
            </el-row>
            <el-row :gutter="20" class="show">
              <el-col>
                <el-form-item label="Show current called student Name">
                  <el-button type="primary" @click="check_out" :loading="checkLoading.out">Send</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-tab-pane>
      </el-tabs>
    </el-col>
  </el-row>
</template>

<script>
// const {or, and, gt, lt} = require('sequelize').Op;

export default {
  name: 'Home',
  title: 'HOME',
  data: function() {
    return {
      dot: false,
      mainLoading: true,
      medicalLoading: false,
      loading: false,
      check: 'check_in',
      // socket: io('http://localhost:2019'),
      form: {
        name: '',
        parent: [],
        code: '',
        course: '',
        teacher: this.$store.state.user.info.name,
        temperature: ''
      },
      student: [],
      studentOut: [],
      students: [],
      parents: [],
      extend: {},
      checkLoading: {
        in: false,
        out: false
      },
      keys: [
        ['1', '2', '3'],
        ['4', '5', '6'],
        ['7', '8', '9'],
        ['0', '.', 'Delete']
      ]
    }
  },
  watch: {
    check() {
      this.form = {
        name: '',
        parent: [],
        code: '',
        course: '',
        teacher: this.$store.state.user.info.name,
        temperature: ''
      }
    },
    'form.name'(val) {
      // console.log(`form.name`, val, this.form, this.extend)
      if (val === '') return false
      let parents = this.students
        .filter(s => {
          return s.name === val
        })
        .map(s => s.parents)[0]
        .map(p => {
          return { label: p, value: p }
        })
      this.extend = this.students.filter(s => {
        return s.name === val
      })[0]
      // console.log(this.extend)
      this.form.course = this.students.filter(s => {
        return s.name === val
      })[0].course
      this.parents = parents
      this.form.parent = [parents[0].value]
      if (this.check === 'check_out')
        this.$socket.emit('getCode', val, code => {
          this.form.code = code
        })
    }
  },
  computed: {
    courses() {
      if (this.$store.state.user.info) {
        return this.$store.state.user.info.courses.map(c => {
          return { label: c, value: c }
        })
      } else {
        return null
      }
    }
  },
  mounted: function() {
    // eslint-disable-next-line
    // console.log(this.$store.state.user.info)

    if (!/windows/gi.test(navigator.userAgent)) return this.$router.push('/min')

    let courses = this.$store.state.user.info.courses

    let where = {
      $or: courses.map(c => {
        if (/%/g.test(c)) {
          return { course: { $like: c } }
        } else {
          return { course: c }
        }
      })
    }
    // eslint-disable-next-line
    // console.log(where)
    this.$socket.emit('get_users', where, (err, us) => {
      this.$socket.emit('get_users_log', us, (err, uss) => {
        // eslint-disable-next-line
        // console.log(uss)
        this.students = uss
        this.student = this.students
          .filter(u => !u.check)
          .map(u => u.name)
          .map(item => {
            return { value: item, label: item }
          })
          .sort(this.nameSort)
        this.studentOut = this.students
          .filter(u => u.check && u.check === 'in')
          .map(u => u.name)
          .map(item => {
            return { value: item, label: item }
          })
          .sort(this.nameSort)
        // eslint-disable-next-line
        // console.log(this.student, this.studentOut)
        this.mainLoading = false
      })
    })

    // this.$socket.on('connect', () => {
    //   // eslint-disable-next-line
    //   console.log('connect...')
    // })

    // this.$socket.on('connected', () => {
    //   // eslint-disable-next-line
    //   console.log('connected!')
    // })
    //
    this.sockets.listener.subscribe('notice', data => {
      // eslint-disable-next-line
      console.log(
        `notice`,
        data,
        this.courses.filter(c => c === data.course)
      )
      if (this.courses.filter(c => new RegExp(c.value.replace('%', '.*'), 'i').test(data.course)).length > 0) {
        switch (data.type) {
          case 'notice':
            this.$notify({
              title: data.title,
              message: data.message,
              duration: data.duration || 0,
              position: 'top-left'
            })
            break

          case 'message':
            this.$message.info({
              type: 'info',
              message: `[${data.message}] ${data.title}`,
              duration: data.duration || 0,
              showClose: data.duration || data.duration === 0
            })
            break

          case 'dot':
            this.dot = true
            if (data.duration && data.duration > 0) {
              setTimeout(() => {
                this.dot = false
              }, data.duration)
            }
            break
        }

        // this.$message.info(data.title)
      }
    })
    // console.log(this)
  },
  // sockets: {
  //   connect: function() {
  //     // eslint-disable-next-line
  //     console.log('connected!')
  //   },
  //   notice: function(data) {
  //     // eslint-disable-next-line
  //     console.log(`notice`, data, this.form)
  //     if (data.course === this.form.course) {
  //       switch (data.type) {
  //         case 'notice':
  //           this.$notify({
  //             title: data.title,
  //             message: data.message,
  //             duration: data.duration || 0,
  //             position: 'top-left'
  //           })
  //           break
  //
  //         case 'message':
  //           this.$message.info({
  //             type: 'info',
  //             message: `[${data.message}] ${data.title}`,
  //             duration: data.duration || 0,
  //             showClose: data.duration || data.duration === 0
  //           })
  //           break
  //
  //         case 'dot':
  //           this.dot = true
  //           if (data.duration && data.duration > 0) {
  //             setTimeout(() => {
  //               this.dot = false
  //             }, data.duration)
  //           }
  //           break
  //       }
  //
  //       this.$message.info(data.title)
  //     }
  //   }
  // },
  methods: {
    handleKeyboardClick(key, val) {
      this.form.temperature = val
    },
    nameSort(a, b) {
      let _a = a.value
          .toLocaleLowerCase()
          .split(' ')
          .map(i => i.charCodeAt(0)),
        _b = b.value
          .toLocaleLowerCase()
          .split(' ')
          .map(i => i.charCodeAt(0))
      for (let k in _a) {
        if (_a[k] !== _b[k]) {
          if (!_a[k]) _a[k] = 0
          if (!_b[k]) _b[k] = 0
          // console.log(_a[k] - _b[k], _a[k], _b[k])
          return _a[k] - _b[k]
        }
      }
      return -1
    },
    updateStudent() {
      this.student = this.students
        .filter(u => !u.check)
        .map(u => u.name)
        .map(item => {
          return { value: item, label: item }
        })
        .sort(this.nameSort)
      this.studentOut = this.students
        .filter(u => u.check && u.check === 'in')
        .map(u => u.name)
        .map(item => {
          return { value: item, label: item }
        })
        .sort(this.nameSort)
    },
    medical() {
      this.medicalLoading = true
      this.$socket.emit('medical', this.form.name, m => {
        this.extend.medical = m
        this.medicalLoading = false
      })
    },
    check_in() {
      if (this.form.name === '') return this.$message.error("You can't set student name!")
      this.checkLoading.in = true
      let data = JSON.parse(JSON.stringify(this.form))
      data.check = 'in'
      if (typeof data.name === 'object') {
        data.name = data.name[0]
      }
      console.log(data)
      this.$socket.emit('notice', data, (err, user) => {
        this.checkLoading.in = false
        this.form = {
          name: '',
          parent: [],
          code: '',
          course: '',
          teacher: this.$store.state.user.info.name,
          temperature: ''
        }
        // eslint-disable-next-line
        console.log(err, user)
        if (!err) {
          this.students.forEach(student => {
            if (student.name === user.name) {
              student.check = 'in'
              this.updateStudent()
              user.parents.forEach(p => {
                student.parents.forEach(sp => {
                  if (sp !== p) student.parents.push(p)
                })
              })
              // student.parents = student.parents.concat(user.parents)
            }
          })

          // console.log(this.students)
        }
      })
    },
    check_out() {
      if (this.form.name === '') return this.$message.error("You can't set student name!")
      this.checkLoading.out = true
      let data = JSON.parse(JSON.stringify(this.form))
      data.check = 'out'
      if (typeof data.name === 'object') {
        data.name = data.name[0]
      }
      this.$socket.emit('notice', data, (err, user) => {
        this.checkLoading.out = false
        this.form = {
          name: '',
          parent: [],
          code: '',
          course: '',
          teacher: this.$store.state.user.info.name,
          temperature: ''
        }
        // eslint-disable-next-line
        console.log(err, user)
        if (!err) {
          this.students.forEach(student => {
            if (student.name === user.name) {
              student.check = 'out'
              this.updateStudent()
              user.parents.forEach(p => {
                student.parents.forEach(sp => {
                  if (sp !== p) student.parents.push(p)
                })
              })
              // student.parents = student.parents.concat(user.parents)
            }
          })
          // console.log(this.students)
        } else {
          // console.log(err)
          if (err.type && err.message) this.$message[err.type](err.message)
        }
      })
    },
    remoteMethod(query) {
      if (query !== '') {
        // this.loading = true
        // setTimeout(() => {
        //   this.loading = false
        this.student = this.students
          .filter(u => !u.check)
          .map(u => u.name)
          .filter(item => {
            return item.toLowerCase().indexOf(query.toLowerCase()) > -1
          })
          .map(item => {
            return { value: item, label: item }
          })
          .sort(this.nameSort)
        // }, 200)
      } else {
        this.student = this.students
          .filter(u => !u.check)
          .map(u => u.name)
          .map(item => {
            return { value: item, label: item }
          })
          .sort(this.nameSort)
      }
      // eslint-disable-next-line
      console.log(this.student)
    },
    remoteMethodOut(query) {
      if (query !== '') {
        // this.loading = true
        // setTimeout(() => {
        //   this.loading = false
        this.studentOut = this.students
          .filter(u => u.check && u.check === 'in')
          .map(u => u.name)
          .filter(item => {
            return item.toLowerCase().indexOf(query.toLowerCase()) > -1
          })
          .map(item => {
            return { value: item, label: item }
          })
          .sort(this.nameSort)
        // }, 200)
      } else {
        this.studentOut = this.students
          .filter(u => u.check && u.check === 'in')
          .map(u => u.name)
          .map(item => {
            return { value: item, label: item }
          })
          .sort(this.nameSort)
      }
      // console.log(this.student)
    }
  },
  destroyed() {
    this.$socket = null
    // Vue.delete(this, 'socket');
  }
}
</script>

<style scoped>
h1 > a {
  font-size: 16px;
}

.el-tag {
  margin-right: 5px;
}

.el-select {
  width: 100%;
}

.hide {
  display: none;
}

.show {
  display: block;
}

@media (max-width: 700px) {
  .el-col.el-col-8 {
    width: 100%;
  }

  .hide {
    display: block;
  }

  .show {
    display: none;
  }

  .el-form-item {
    margin: 0;
  }

  .el-form--label-top .el-form-item__label {
    padding: 0;
  }

  .el-form-item__label {
    line-height: unset;
  }
}
</style>

<style>
.el-popover.el-popper {
  padding: 0 !important;
}

.akeyboard-keyboard-keys {
  width: 80px;
}

/*.el-input.is-disabled.temp .el-input__inner {*/
/*  cursor: default !important;*/
/*}*/

@media (max-width: 700px) {
  .el-form--label-top .el-form-item__label {
    padding: 0;
  }

  .el-form-item__label {
    line-height: unset;
  }
}
</style>
